export default __webpack_public_path__ + "static/carsten-240-62840a653ffb0be246c6353b95129729.png";